// @ts-ignore
/* eslint-disable */
import { request } from '../../request'

/** No comments are provided by the backend GET /projects/${param0}/versions */
export async function versionsControllerList(
  // Param type generated by superposition
  params: API.VersionsControllerListParams,
  options?: { [key: string]: any },
) {
  const { projectId: param0, ...queryParams } = params
  return request<any>(`/projects/${param0}/versions`, {
    method: 'GET',
    params: {
      // page has a default value: 1
      page: '1',
      // pageSize has a default value: 20
      pageSize: '20',
      ...queryParams,
    },
    ...(options || {}),
  })
}

/** No comments are provided by the backend POST /projects/${param0}/versions */
export async function versionsControllerSnapshot(
  // Param type generated by superposition
  params: API.VersionsControllerSnapshotParams,
  body: API.SnapshotDto,
  options?: { [key: string]: any },
) {
  const { projectId: param0, ...queryParams } = params
  return request<any>(`/projects/${param0}/versions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  })
}
